import { TableName } from '@/common/enums/TableName';
import { NoteListComponent } from '@/note/note-list/note-list.component';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface BagPaymentTermNotesDialogData {
	paymentTermId: number;
	reservationId: number;
}

@Component({
	selector: 'app-bag-payment-term-notes-dialog',
	templateUrl: './bag-payment-term-notes-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NoteListComponent],
	standalone: true,
})
export class BagPaymentTermNotesDialogComponent {
	readonly data = inject<BagPaymentTermNotesDialogData>(MAT_DIALOG_DATA);
	readonly dialogRef = inject(MatDialogRef<BagPaymentTermNotesDialogComponent>);

	protected readonly TableName = TableName;
}
